import type * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import * as fragments from '../fragments'

const DOC = gql`
  ${fragments.process.DOC}
  query ZoneProcesses($zoneId: ID!, $tenantId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        processes {
          ...FragmentProcessEssentials
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.ZoneProcessesQuery,
    ents.core.relay.processes.Process.Essentials[] | undefined,
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'processes',
        graphql.transformers.OUT.list(fragments.process.TRANSFORMER, {
          onNullish: 'remove',
        }),
      ),
    ),
  ),
  [],
)

export const executor = graphql.createExecutor<
  graphql.schema.ZoneProcessesQuery,
  ents.core.relay.processes.Process.Essentials[],
  graphql.schema.ZoneProcessesQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
